import { React, useState, useEffect, useContext } from "react";
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import { Link } from "react-router-dom";
import HeaderSection from "../banner/HeaderSection";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import Form from "../../../component/utilities/Forms";
import editImg from "../../../assets/img/icon/edit.svg";
import deleteImg from "../../../assets/img/icon/delete.svg";
import { Modal, Button } from "react-bootstrap";
import { AuthContext } from "../../../component/context/AuthContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactSwitch from "react-switch";
import * as SwitchProps from "../../../component/utilities/ReactSwitchReactSwitchProps";
import { EditIcon, DeleteIcon, CheckIcon, XIcon } from '../../../component/utilities/ActionIcons';
import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";

function AdminLibraryListing() {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [validate, setValidate] = useState({});

  const handleClearValidate = (name) => {
    if (validate.validate && validate.validate[name]) {
      setValidate({
        validate: { ...validate.validate, [name]: undefined },
      });
    }
  };
  const [disabled, setDisabled] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [technologyId, setTechnologyId] = useState(0);
  const MySwal = withReactContent(Swal);
  const [listLimit, setListLimit] = useState(50);

  const [action, setAction] = useState("");

  /** For Modalpopup */
  const [show, setShow] = useState(false);

  /* START DATATABLE */
  const [totalRecords, settotalRecords] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [maxPageLimit, setMaxPageLimit] = useState(10);
  const [minPageLimit, setMinPageLimit] = useState(0);

  //Search
  const [searchTechnologyStatus, setSearchTechnologyStatus] = useState("");
  const [searchTechnologyName, setSearchTechnology] = useState("");
  const [dataSort, setDataSort] = useState({
    order: "desc",
    order_by: "id",
  });
  const pageNumberLimit = { perPage };

  //For Form
  const [technologyName, setTechnologyName] = useState("");
  const [versions, setVersions] = useState("");
  const [showInput, setShowInput] = useState(false);

  const [techImage, setTechImage] = useState([]);
  const [techImagePath, setTechImagePath] = useState("");
  const [techId, setTechId] = useState(0);
  const [status, setStatus] = useState(false);
  const [allVersions, setAllVersions] = useState([]);
  const [dbVersionValue, setDbVersionValue] = useState("");
  const [flag, setFlag] = useState(false);
  const [existingVersionsDetailed, setExistingVersionsDetailed] = useState([]);
  const [editingVersionId, setEditingVersionId] = useState(null);
  const [editingVersionName, setEditingVersionName] = useState("");
  const [inlineEditingVersionId, setInlineEditingVersionId] = useState(null);
  const [inlineEditingName, setInlineEditingName] = useState("");

  let isToken = "";
  if (authUserData) {
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
    }
  }


  const [searchParam, setSearchParam] = useState({
    "srchStatus": searchTechnologyStatus,
    "srchTechnology": searchTechnologyName,
  });

  const [versionValue, setVersionValue] = useState("");
  const handleOnchange = (val) => {
    handleClearValidate("versionValue");
    if (val.indexOf("other") !== -1) {
      setShowInput(true);
      setFlag(true);
    } else {
      setShowInput(false);
      setVersions("");
    }
    setVersionValue(val);
  };

  useEffect(() => {
    fetchTechnologyData(searchParam, dataSort, activePage, perPage);
  }, [searchParam, dataSort, activePage, listLimit]);

  const onTechImageSelect = (event) => {
    setTechImagePath(URL.createObjectURL(event));
    setTechImage(event);
  };

  function handleShow(action, technologyId) {
    setValidate({});
    const technology_id = technologyId ? technologyId : 0;
    setTechnologyId(technology_id);
    setTechnologyName("");
    setVersions("");
    setVersionValue("");
    setTechImage("");
    setTechImagePath("");
    setStatus("");
    setDbVersionValue("");
    setAllVersions([{ label: "other", value: "other" }]);

    if (technology_id !== 0) {
      getVersions(technology_id);
    }
    setAction(action);
    setShowInput(false);
    setShow(true);
  }

  async function technologySearch() {
    setSearchParam({
      "srchStatus": searchTechnologyStatus,
      "srchTechnology": searchTechnologyName,
    });
    setDataSort({
      order: "desc",
      order_by: "id",
    });
    setActivePage("1");
  }

  function clearSearch() {
    setSearchTechnologyStatus("");
    setSearchTechnology("");
    setVersions("");

    setSearchParam({
      srchStatus: "",
      srchTechnology: ""
    });
    setDataSort({
      order: "desc",
      order_by: "id",
    });
    setActivePage("1");
  }

  const handleClose = () => {
    setValidate({});
    setShow(false);
    setTechnologyId(0);
    setTechnologyName("");
    setVersions("");
    setStatus("");
  };

  async function getVersions(technology_id, skipRefresh = false) {
    let apiUrl = CONST.GET_TECHNOLOGY_VERSIONS + `${technology_id}`;
    let strMethod = "get";

    await axios({
      method: strMethod,
      url: apiUrl,
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          let versionDetails = response.data.data;
          setExistingVersionsDetailed(versionDetails); // Store detailed version info
          setAllVersions([
            ...versionDetails.map((v) => ({
              label: v.version,
              value: v.version, // Use name as value for consistency
            })),
            { label: "other", value: "other" },
          ]);
          if (!skipRefresh) {
            fetchTechnologyById(technology_id);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleEditVersionClick = (vId, oldName) => {
    setInlineEditingVersionId(vId);
    setInlineEditingName(oldName);
  };

  const cancelInlineEdit = () => {
    setInlineEditingVersionId(null);
    setInlineEditingName("");
  };

  const saveInlineEdit = async (vId, oldName) => {
    if (!inlineEditingName.trim()) {
      toast.warning("Version name is required.");
      return;
    }
    const newName = inlineEditingName.trim();
    setLoading(true);
    try {
      const response = await axios.post(CONST.UPDATE_TECHNOLOGY_VERSION, {
        id: vId,
        version: newName
      }, {
        headers: { Authorization: `Bearer ${isToken}` }
      });

      if (response.data.status === "success") {
        toast.success(response.data.message);
        setInlineEditingVersionId(null);
        setInlineEditingName("");
        
        // Update the selected versions string locally to reflect the rename
        if (versionValue) {
          const updatedVersionValue = versionValue.split(',')
            .map(v => v.trim() === oldName.trim() ? newName : v.trim())
            .join(',');
          setVersionValue(updatedVersionValue);
        }

        // Update local versions lists immediately for instant UI feedback
        setExistingVersionsDetailed(prev => prev.map(v => v.id === vId ? { ...v, version: newName } : v));
        setAllVersions(prev => prev.map(v => v.label === oldName ? { label: newName, value: newName } : v));

        getVersions(technologyId, true); // Refresh versions list but skip full tech refresh
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update version.");
    }
    setLoading(false);
  };

  async function handleDeleteVersion(vId, vName) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete version "${vName}"? This might affect related questions.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.delete(CONST.DELETE_TECH_VERSIONS, {
            headers: { Authorization: `Bearer ${isToken}` },
            data: {
              technology_id: technologyId,
              version: [vName]
            }
          });

          if (response.data.status === "success") {
            toast.success("Version deleted successfully.");
            // Update the selected versions string locally to reflect the deletion
            if (versionValue) {
              const updatedVersionValue = versionValue.split(',')
                .filter(v => v.trim() !== vName.trim())
                .join(',');
              setVersionValue(updatedVersionValue);
            }

            // Update local versions lists immediately for instant UI feedback
            setExistingVersionsDetailed(prev => prev.filter(v => v.id !== vId));
            setAllVersions(prev => prev.filter(v => v.label !== vName));

            getVersions(technologyId, true); // Refresh versions list but skip full tech refresh
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          toast.error(error.response?.data?.message || "Failed to delete version.");
        }
        setLoading(false);
      }
    });
  }

  function deleteHandler(delete_tech_id) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Technology?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        if (delete_tech_id > 0) {
          setLoading(true);
          axios
            .delete(CONST.DELETE_TECHNOLOGY_DETAILS, {
              headers: {
                Authorization: `Bearer ${isToken}`,
              },
              data: {
                technology_id: delete_tech_id,
              },
            })
            .then((response) => {
              if (response) {
                if (response.data.status == "error") {
                  toast.error(response.data.message);
                  //getVersions();
                } else {
                  toast.success(response.data.message);
                  fetchTechnologyData(
                    searchParam,
                    dataSort,
                    activePage,
                    perPage
                  );
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              toast.error("Something went wrong. Please try again." + error);
            });
          setLoading(false);
        }
      }
    });
  }

  //fetch all Technology data by id
  async function fetchTechnologyById(technologyId) {
    setLoading(true);
    let apiUrl = CONST.GET_TECHNOLOGY_BY_ID + `${technologyId}`;
    let strMethod = "put";

    await axios({
      method: strMethod,
      url: apiUrl,
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        const status = response.data.status;

        if (status === "success") {
          let technologyData = response.data.data ? response.data.data : [];
          setTechnologyName(
            technologyData["name"] ? technologyData["name"] : ""
          );
          let arrVersion = technologyData["technologies_has_versions"]
            ? technologyData["technologies_has_versions"].map((v, index) =>
              v.version.trim()
            )
            : "";

          setDbVersionValue(arrVersion);
          setVersionValue(arrVersion.toString());
          setTechImage(
            technologyData["image_path"] ? technologyData["image_path"] : ""
          );
          setStatus(technologyData["status"] ? technologyData["status"] : "");
        }
      })
      .catch((error) => {
        alert(error);
      });
    setLoading(false);
  }

  //fetch all technology details
  async function fetchTechnologyData(
    paramSearch,
    paramSort,
    paramPage,
    paramLimit
  ) {
    setLoading(true);
    await axios
      .post(
        CONST.GET_TECHNOLOGY_LIST,
        {
          limit: paramLimit,
          search_input: paramSearch,
          page_number: paramPage,
          sort: paramSort,
        },
        {
          headers: {
            Authorization: `Bearer ${isToken}`,
          },
        }
      )
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          setData(response.data.data);
          setTotalRows(response.data.count);
          settotalRecords(response.data.count);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => { });
    setLoading(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    let arrDifference = "";

    let validationFields = {
      technologyName: {
        value: technologyName,
        isRequired: true,
        label: "Technology Name",
      },
      versionValue: {
        value: versionValue,
        isRequired: true,
        label: "Versions",
      },
      status: {
        value: status,
        isRequired: true,
        label: "Status",
      },
    };

    if (showInput) {
      validationFields.versions = {
        value: versions,
        isRequired: true,
        label: "Other Versions",
      };
    }

    let validator = Form.validator(validationFields);

    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    }

    if (isValid) {
      setDisabled(true);
      let apiUrl = "";
      let sucessMessage = "";
      let strMethod = "";

      if (technologyId == 0) {
        apiUrl = CONST.ADD_TECHNOLOGY;
        strMethod = "post";
        sucessMessage = "Technology added succesfully";
      } else {
        apiUrl = CONST.EDIT_TECHNOLOGY;
        strMethod = "post";
        sucessMessage = "Technology updated succesfully";
      }

      var selectVersionValue = versionValue;
      var strUpdatedValue = versionValue.split(",");
      if (dbVersionValue !== "") {
        arrDifference = dbVersionValue.filter(
          (i) => strUpdatedValue.indexOf(i) === -1
        );
        arrDifference = arrDifference.toString();
      }

      if (selectVersionValue.indexOf("other") !== -1) {
        selectVersionValue = versionValue.replace("other", "");
      }

      if (versions !== "") {
        selectVersionValue = selectVersionValue + versions;
      }

      selectVersionValue = selectVersionValue.trim();
      await axios({
        method: strMethod,
        url: apiUrl,
        data: {
          name: technologyName,
          versions: [selectVersionValue],
          status: status == "1" || status == "" ? "1" : "0",
          technology_id: technologyId,
          image: techImage,
        },
        headers: {
          Authorization: `Bearer ${isToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response) {
            if (response.data.status == "error") {
              setDisabled(false);
              toast.error(response.data.message || "Something went wrong. Please try again.");
            } else {
              toast.success(sucessMessage);
              setDisabled(false);
              fetchTechnologyData(searchParam, dataSort, activePage, perPage);
              handleClose();
              if (arrDifference.length > 0 && technologyId > 0) {
                let apiUrl = CONST.DELETE_TECH_VERSIONS;
                let strMethod = "delete";
                axios({
                  method: strMethod,
                  url: apiUrl,
                  data: {
                    technology_id: technologyId,
                    version: [arrDifference],
                  },
                  headers: {
                    Authorization: `Bearer ${isToken}`,
                  },
                })
                  .then((response) => {
                    const status = response.data.status;
                    if (status == "success") {
                      fetchTechnologyData(
                        searchParam,
                        dataSort,
                        activePage,
                        perPage
                      );
                      //console.log(response.data.message);
                    } else {
                      //console.log(response.data.message);
                    }
                  })
                  .catch((error) => {
                    toast.error(error.response?.data?.message || "There was an error.");
                  });
              }
            }
          }
        })
        .catch((error) => {
          setDisabled(false);
          setLoading(false);
          toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
        });
    }
  };

  const handleChangeStatus = (index, status_value, Technology_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios
          .post(
            CONST.UPDATE_TECHNOLOGY_STATUS,
            {
              technologyId: Technology_id,
              status: status_value == "0" ? "1" : "0",
            },
            {
              headers: {
                Authorization: `Basic ${isToken}`,
              },
            }
          )
          .then((response) => {
            const status = response.data.status;
            if (status == "success") {
              toast.success(response.data.message);
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            toast.error("There was an error.");
          });
        setLoading(false);

        const newData = [...data];
        newData[index].status = status_value == 0 ? 1 : 0;
        setData(newData);
      }
    });
  };

  const columns = [
    {
      width: "3%"
    },
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "10%",
    },
    {
      name: "Technology",
      selector: (row) => row.name,
      sortable: true,
      sortField: "name",
      width: "25%",
      cell: (row) => (
        <Link to={CONST.ADMIN_PRE + "techQuestionAnwser/" + row.id}>
          {row.name}
        </Link>
      ),
    },
    {
      name: "Image",
      selector: (row) => (
        <div className="col-md-8 mt-4 ">
          {row.image_path !== "" && row.image_path !== null ? (
            <img src={CONST.HOST + row.image_path} alt={row.name} />
          ) : (
            "-"
          )}
        </div>
      ),
      width: "15%",
    },
    {
      name: "Versions",
      selector: (row) =>
        row.versions
          ? row.versions.map((v) => v.version).join(", ")
          : "-",
      width: "25%",
    },
    {
      name: "Status",
      omit: authUserData[0]?.is_admin != 1,
      width: "10%",
      selector: (row, index) => (
        <ReactSwitch
          onColor={SwitchProps.onColor}
          onHandleColor={SwitchProps.onHandleColor}
          handleDiameter={SwitchProps.handleDiameter}
          uncheckedIcon={SwitchProps.uncheckedIcon}
          checkedIcon={SwitchProps.checkedIcon}
          boxShadow={SwitchProps.boxShadow}
          activeBoxShadow={SwitchProps.activeBoxShadow}
          height={SwitchProps.height}
          width={SwitchProps.width}
          className={SwitchProps.className}
          checked={row.status == 1 ? true : false}
          onChange={() => {
            handleChangeStatus(index, row.status, row.id);
          }}
        />
      ),
    },
    {
      name: "Action",
      width: "12%",
      wrap: true,
      sortable: false,
      cell: (row) => <Action row={row} />,
    },
  ];

  const Action = ({ row }) => (
    <>
      {authUserData[0]?.is_admin == 1 && (
        <>
          <EditIcon onClick={() => handleShow("Edit", row.id)} tooltip="Edit Technology" />
          <DeleteIcon onClick={() => deleteHandler(row.id)} tooltip="Delete Technology" />
        </>
      )}

      <Link
        to={CONST.ADMIN_PRE + "techQuestionAnwser/" + row.id}
        className="ms-2 text-secondary"
        title="Manage Articles"
      >
        <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <path d="M13 5h8"></path>
          <path d="M13 9h5"></path>
          <path d="M13 15h8"></path>
          <path d="M13 19h5"></path>
          <path d="M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
          <path d="M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
        </svg>
      </Link>
    </>
  );

  const handleSort = async (column, sortDirection) => {
    setActivePage(1);
    setSearchParam({
      "srchStatus": searchTechnologyStatus,
      "srchTechnology": searchTechnologyName,
    });

    setDataSort({
      order: sortDirection,
      order_by: column.sortField,
    });
    /*  setLoading(false); */
  };
  /*  PAGINATION FUNCTIONS  */
  const handlePageChange = async (page) => {
    setActivePage(parseInt(page));
  };

  const BootyPagination = ({
    rowsPerPage,
    rowCount,
    onChangePage,
    onChangeRowsPerPage, // available but not used here
    currentPage,
  }) => {
    function toPages(pages) {
      const results = [];
      for (let i = 1; i <= pages; i++) {
        results.push(i);
      }
      return results;
    }
    function getNumberOfPages(rowCount, rowsPerPage) {
      return Math.ceil(rowCount / rowsPerPage);
    }

    const handleBackButtonClick = async () => {
      if ((currentPage - 1) % pageNumberLimit === 0) {
        setMaxPageLimit(maxPageLimit - pageNumberLimit);
        setMinPageLimit(minPageLimit - pageNumberLimit);
      }
      onChangePage(currentPage - 1);
    };

    const handleNextButtonClick = async () => {
      if (currentPage + 1 > maxPageLimit) {
        setMaxPageLimit(maxPageLimit + pageNumberLimit);
        setMinPageLimit(minPageLimit + pageNumberLimit);
      }

      onChangePage(currentPage + 1);
    };

    const handlePageNumber = (e) => {
      onChangePage(Number(e.target.value));
    };

    let paginationText = "Page:  " + currentPage + ", Showing ";

    paginationText =
      paginationText +
      ((currentPage - 1) * perPage + 1) +
      " to " +
      perPage * currentPage;
    paginationText = paginationText + " of " + rowCount + " entries;";

    const pages = getNumberOfPages(rowCount, rowsPerPage);
    const pageItems = toPages(pages);
    const nextDisabled = currentPage === pageItems.length;
    const previosDisabled = currentPage === 1;

    const pageNumbers = pageItems.map((page) => {
      if (page <= maxPageLimit && page > minPageLimit) {
        return (
          <li
            key={page}
            id={page}
            className={`page-item ${currentPage === page ? "active" : ""}`}
          >
            <button
              className={`page-link ${currentPage === page ? "active" : ""}`}
              onClick={handlePageNumber}
              value={page}
            >
              {page}
            </button>
          </li>
        );
      } else {
        return null;
      }
    });
    let pageIncrementEllipses = null;
    if (pageItems.length > maxPageLimit) {
      pageIncrementEllipses = (
        <li className="page-item" onClick={handleNextButtonClick}>
          &hellip;
        </li>
      );
    }
    let pageDecremenEllipses = null;
    if (minPageLimit >= 1) {
      pageDecremenEllipses = (
        <li className="page-item" onClick={handleBackButtonClick}>
          &hellip;
        </li>
      );
    }
    return (
      <div className="card-footer d-flex justify-content-between">
        <p className="m-0 text-muted">{paginationText}</p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleBackButtonClick}
              disabled={previosDisabled}
              aria-disabled={previosDisabled}
              aria-label="previous page"
              pagerangedisplayed={10}
            >
              «
            </button>
          </li>
          {pageDecremenEllipses}
          {pageNumbers}
          {pageIncrementEllipses}
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleNextButtonClick}
              disabled={nextDisabled}
              aria-disabled={nextDisabled}
              aria-label="next page"
            >
              »
            </button>
          </li>
        </ul>
      </div>
    );
  };
  /* END DATATABLE */
  const CustomLoader = () => (
    <div style={{ padding: "24px" }}>
      <DivLoader color="primary" />
    </div>
  );
  return (
    <>
      <Loading
        loading={fullLoading}
        background="rgba(0, 0, 0, 0.5)"
        loaderColor="#fff"
      />
      <HeaderSection
        title="Manage"
        heading="Technology"
        addButton={authUserData[0]?.is_admin == 1 ? () => handleShow("Add", 0) : null}
        addLink="#"
        addLinkName={authUserData[0]?.is_admin == 1 ? "Add Technology" : ""}
        linktype="add"
      />
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Listing</h3>
                </div>
                <div className="card-body border-bottom py-3">
                  <div className="d-flex align-items-end gap-3 flex-wrap">

                    {/* Technology */}
                    <div style={{ minWidth: "220px" }}>
                      <label className="form-label required">Technology</label>
                      <input
                        type="text"
                        name="searchTechnologyName"
                        id="searchTechnologyName"
                        className="form-control"
                        placeholder="Enter Technology Name"
                        onChange={(e) => setSearchTechnology(e.target.value)}
                        value={searchTechnologyName}
                      />
                    </div>

                    {/* Status */}
                    <div style={{ minWidth: "180px" }} className="ml-3">
                      <label className="form-label required ">Status</label>
                      <select
                        className="form-select"
                        name="searchTechnologyStatus"
                        id="searchTechnologyStatus"
                        onChange={(e) => setSearchTechnologyStatus(e.target.value)}
                        value={searchTechnologyStatus}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Deactive</option>
                      </select>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex gap-2">

                      {/* Search Button */}
                      <button
                        type="button"
                        id="btnSearch"
                        className="btn btn-blue d-flex align-items-center ml-3"
                        onClick={technologySearch}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-search"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                        >
                          <circle cx="10" cy="10" r="7"></circle>
                          <line x1="21" y1="21" x2="15" y2="15"></line>
                        </svg>
                        <span>Search</span>
                      </button>

                      {/* Clear Button */}
                      <button
                        type="button"
                        id="btnReset"
                        className="btn btn-outline-primary d-flex align-items-center ml-3"
                        onClick={clearSearch}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-x"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                        >
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                        <span>Clear</span>
                      </button>

                    </div>

                  </div>
                </div>
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    SortableContext={data}
                    data={data}
                    progressPending={loading}
                    progressComponent={<CustomLoader />}
                    pagination="true"
                    paginationServer
                    paginationTotalRows={totalRows}
                    //onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    paginationPerPage={perPage}
                    paginationComponent={BootyPagination}
                    sortServer
                    onSort={handleSort}
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{action} Technology</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form method="POST" onSubmit={handleSubmit} autoComplete={"off"}>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label required">Technology Name</label>
                <div>
                  <input
                    type="text"
                    name="technologyName"
                    id="technologyName"
                    className={`form-control ${validate.validate && validate.validate.technologyName
                        ? "is-invalid "
                        : ""
                      }`}
                    aria-describedby=""
                    placeholder="Enter Technology name"
                    onChange={(e) => {
                      setTechnologyName(e.target.value);
                      handleClearValidate("technologyName");
                    }}
                    value={technologyName}
                  />
                  {validate.validate && validate.validate.technologyName && (
                    <div className="invalid-feedback">
                      {validate.validate.technologyName}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <label className="form-label required">Versions </label>
                  <MultiSelect
                    options={allVersions}
                    value={versionValue}
                    onChange={handleOnchange}
                    closeMenuOnSelect={flag}
                    className={`custMultiSelect ${validate.validate && validate.validate.versionValue
                      ? "is-invalid "
                      : ""
                      }`}
                  />
                  {validate.validate && validate.validate.versionValue && (
                    <div className="invalid-feedback d-block">
                      {validate.validate.versionValue}
                    </div>
                  )}

                  {/* Manage Selected Versions Section */}
                  {technologyId !== 0 && versionValue && (
                    <div className="mt-2 d-flex flex-wrap gap-2">
                      {versionValue.split(",").map((vName) => {
                        const vNameTrimmed = vName.trim();
                        const versionObj = existingVersionsDetailed.find(v => v.version === vNameTrimmed);
                        if (!versionObj) return null;
                        return (
                          <div key={versionObj.id} className="badge bg-white text-dark border d-flex align-items-center gap-2 p-1 px-2 shadow-sm rounded-pill mb-1">
                            {inlineEditingVersionId === versionObj.id ? (
                               <div className="d-flex align-items-center gap-2">
                                  <input 
                                    type="text" 
                                    className="form-control form-control-sm border-primary" 
                                    style={{ width: '100px', height: '24px', fontSize: '0.75rem' }}
                                    value={inlineEditingName}
                                    onChange={(e) => setInlineEditingName(e.target.value)}
                                    autoFocus
                                  />
                                  <CheckIcon 
                                    onClick={() => saveInlineEdit(versionObj.id, versionObj.version)}
                                    tooltip="Save Version"
                                  />
                                  <XIcon 
                                    onClick={cancelInlineEdit}
                                    tooltip="Cancel"
                                  />
                               </div>
                            ) : (
                               <>
                                  <span className="fw-bold px-1">{versionObj.version}</span>
                                  <span className="d-flex gap-1 border-start ps-2">
                                     <EditIcon 
                                       onClick={() => handleEditVersionClick(versionObj.id, versionObj.version)} 
                                       tooltip="Rename Inline"
                                       style={{ cursor: 'pointer' }}
                                     />
                                     <DeleteIcon 
                                       onClick={() => handleDeleteVersion(versionObj.id, versionObj.version)} 
                                       tooltip="Delete"
                                       style={{ cursor: 'pointer' }}
                                     />
                                  </span>
                               </>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {showInput && (
                    <div className="mt-2 ani-fade-in">
                      <input
                        type="text"
                        name="versions"
                        id="versions"
                        className={`form-control ${validate.validate && validate.validate.versions
                            ? "is-invalid "
                            : ""
                          }`}
                        placeholder="Enter other versions"
                        onChange={(e) => {
                          setVersions(e.target.value);
                          handleClearValidate("versions");
                        }}
                        value={versions}
                      />
                      {validate.validate && validate.validate.versions && (
                        <div className="invalid-feedback">
                          {validate.validate.versions}
                        </div>
                      )}
                    </div>
                  )}
                </div>

              <div className="col-md-6 mt-3">
                <label className="form-label">Upload Image</label>

                <input
                  type="file"
                  name="techImage"
                  id="techImage"
                  className={`form-control`}
                  accept="image/png, image/jpg, image/jpeg"
                  onChange={(e) => onTechImageSelect(e.target.files[0])}
                />
                {techImagePath !== "" ? (
                  <img src={techImagePath} alt="techImage" width="150" />
                ) : techImage !== "" && technologyId !== 0 ? (
                  <img
                    src={CONST.HOST + techImage}
                    alt="techImage"
                    width="150"
                  />
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-6 mt-3">
                <label className="form-label required">Status</label>
                <select
                  className={`form-select form-control ${validate.validate && validate.validate.status
                      ? "is-invalid "
                      : ""
                    }`}
                  name="status"
                  id="status"
                  placeholder="Select status"
                  onChange={(e) => {
                    setStatus(e.target.value);
                    handleClearValidate("status");
                  }}
                  value={status}
                >
                  <option value="">Select</option>
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
                {validate.validate && validate.validate.status && (
                  <div className="invalid-feedback">
                    {validate.validate.status}
                  </div>
                )}
              </div>
            </div>
            <input
              type="hidden"
              name="technologyId"
              id="technologyId"
              value={technologyId}
            />
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={disabled}>
            {disabled ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AdminLibraryListing;
